var _path, _path2, _path3, _circle, _circle2, _circle3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAiToolsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 2C9.55228 2 10 2.44772 10 3V4H11C11.5523 4 12 4.44772 12 5C12 5.55228 11.5523 6 11 6H10V7C10 7.55228 9.55228 8 9 8C8.44772 8 8 7.55228 8 7V6H7C6.44772 6 6 5.55228 6 5C6 4.44772 6.44772 4 7 4H8V3C8 2.44772 8.44772 2 9 2Z",
    fill: "#455A64"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14 10C14.5523 10 15 10.4477 15 11V12H16C16.5523 12 17 12.4477 17 13C17 13.5523 16.5523 14 16 14H15V15C15 15.5523 14.5523 16 14 16C13.4477 16 13 15.5523 13 15V14H12C11.4477 14 11 13.5523 11 13C11 12.4477 11.4477 12 12 12H13V11C13 10.4477 13.4477 10 14 10Z",
    fill: "#455A64"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4 10C4.55228 10 5 10.4477 5 11V12H6C6.55228 12 7 12.4477 7 13C7 13.5523 6.55228 14 6 14H5V15C5 15.5523 4.55228 16 4 16C3.44772 16 3 15.5523 3 15V14H2C1.44772 14 1 13.5523 1 13C1 12.4477 1.44772 12 2 12H3V11C3 10.4477 3.44772 10 4 10Z",
    fill: "#455A64"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 9,
    cy: 13,
    r: 1,
    fill: "#455A64"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 14,
    cy: 5,
    r: 1,
    fill: "#455A64"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 4,
    cy: 5,
    r: 1,
    fill: "#455A64"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAiToolsIcon);
export default __webpack_public_path__ + "static/media/ai_tools_icon.99478e3bf51a61318b84f6c7da94ee57.svg";
export { ForwardRef as ReactComponent };